module.exports = __webpack_public_path__ + "static/media/about_card.0837bdce.jpg";